import MuiBackdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import CircularProgress from "@mui/material/CircularProgress";

export interface BackdropProps {
  backdropLoading?: boolean;
}

export function Backdrop({ backdropLoading = false }: BackdropProps) {
  return (
    <div>
      <MuiBackdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropLoading}
      >
        <Box sx={{ m: 1, position: "relative" }}>
          <Fab aria-label="save" color="primary">
            {/* Preserve the legacy unoptimized image behavior in this migration. */}
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src="/images/logo-box.png"
              alt="backdrop icon"
              style={{ width: "25px", height: "25px" }}
            />
          </Fab>
          {backdropLoading && (
            <CircularProgress
              size={68}
              sx={{
                color: "inherit",
                position: "absolute",
                top: -6,
                left: -6,
                zIndex: 1,
              }}
            />
          )}
        </Box>
      </MuiBackdrop>
    </div>
  );
}
